export default __webpack_public_path__ + "static/dazz-933334c1fab00ffc4914c30e9e0ed6c4.png";